export default __webpack_public_path__ + "bb991628bae851ca80b60bc5111f1791.png";